import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import PsychologyIcon from "@mui/icons-material/Psychology";
import MedicationLiquidIcon from "@mui/icons-material/MedicationLiquid";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import HealingIcon from "@mui/icons-material/Healing";
import GeneralQuestionsModal from "./GeneralQuestionsModal";
import NutritionQuestionsModal from "./NutritionQuestionsModal";
import PhysicalQuestionsModal from "./PhysicalQuestionsModal";
import TrainQuestionsModal from "./TrainQuestionsModal";
import PsychologyQuestionsModal from "./PsychologyQuestionsModal";
import Loading from "../../Loading/Loading";

const SelectFormAnswers = ({
  generalAnswers,
  nutricionistAnswers,
  phisicalAnswers,
  TrainAnswers,
  psicologyAnswers,
  setAnswers,
}) => {
  const [loading, setLoading] = useState(false);
  const [showModalGeneral, setShowModalGeneral] = useState(false);
  const [showModalPhysio, setShowModalPhysio] = useState(false);
  const [showModalPhysicology, setShowModalPhysicology] = useState(false);
  const [showModalPhysical, setShowModalPhysical] = useState(false);
  const [showModalNutrition, setShowModalNutrition] = useState(false);

  const styleCard = {
    wrapCard: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: 120,
      height: 100,
      backgroundColor: "rgba(212, 216, 216, 0.32)",
      borderRadius: 2,
      gap: 1,
      boxShadow: 3,
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      cursor: "pointer",
      "&:hover": {
        transform: "scale(1.2)",
        boxShadow: 6,
      },
    },
    text: { fontSize: 20 },
    icon: { fontSize: 35, color: "#e7ef7d" },
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 5,
        alignItems: "center",
        minHeight: "50vh",
      }}
    >
      <Loading loading={loading} />
      <GeneralQuestionsModal
        open={showModalGeneral}
        setLoading={setLoading}
        setOpen={setShowModalGeneral}
        answers={generalAnswers}
        setAnswers={setAnswers}
      />
      <NutritionQuestionsModal
        open={showModalNutrition}
        setLoading={setLoading}
        setOpen={setShowModalNutrition}
        answers={nutricionistAnswers}
        setAnswers={setAnswers}
      />
      <PhysicalQuestionsModal
        open={showModalPhysio}
        setLoading={setLoading}
        setOpen={setShowModalPhysio}
        answers={phisicalAnswers}
        setAnswers={setAnswers}
      />
      <TrainQuestionsModal
        open={showModalPhysical}
        setLoading={setLoading}
        setOpen={setShowModalPhysical}
        answers={TrainAnswers}
        setAnswers={setAnswers}
      />

      <PsychologyQuestionsModal
        open={showModalPhysicology}
        setLoading={setLoading}
        setOpen={setShowModalPhysicology}
        answers={psicologyAnswers}
        setAnswers={setAnswers}
      />

      {/* Card de Nutrición */}
      <Box sx={styleCard?.wrapCard} onClick={() => setShowModalNutrition(true)}>
        <MedicationLiquidIcon sx={styleCard?.icon} />
        <Typography sx={styleCard?.text}>Nutrición</Typography>
      </Box>

      {/* Card de Fisioterapia */}
      <Box sx={styleCard?.wrapCard} onClick={() => setShowModalPhysio(true)}>
        <HealingIcon sx={styleCard?.icon} />
        <Typography sx={styleCard?.text}>Fisioterapia</Typography>
      </Box>

      {/* Card de Psicología */}
      <Box
        sx={styleCard?.wrapCard}
        onClick={() => setShowModalPhysicology(true)}
      >
        <PsychologyIcon sx={styleCard?.icon} />
        <Typography sx={styleCard?.text}>Psicológico</Typography>
      </Box>

      {/* Card de Físico */}
      <Box sx={styleCard?.wrapCard} onClick={() => setShowModalPhysical(true)}>
        <DirectionsRunIcon sx={styleCard?.icon} />
        <Typography sx={styleCard?.text}>Físico</Typography>
      </Box>

      {/* Card de General */}
      <Box sx={styleCard?.wrapCard} onClick={() => setShowModalGeneral(true)}>
        <LocalHospitalIcon sx={styleCard?.icon} />
        <Typography sx={styleCard?.text}>General</Typography>
      </Box>
    </Box>
  );
};

export default SelectFormAnswers;
